import errorData from "@/mixins/error"
import { mapGetters, mapActions } from 'vuex'

export default {
    data() {
        return {
            default: ""
        }
    },
    mixins: [errorData],
    computed: {
        ...mapGetters({
            data: 'data/getData',
            mode: 'data/getMode'
        })
    },
    methods: {
        ...mapActions({
            spinShow: 'view/spinShow',
            spinHide: 'view/spinHide',
            haveResult: 'view/haveResult',
            addError: 'error/addError',
            clearError: 'error/clearError',
            update: 'data/update',
            eval: 'evaluate/evaluate',
            setResult: 'result/setResult'
        }),
        evaluate() {
            //ローディングスピンを表示
            this.spinShow()
            this.clearError()
            this.update({ mode: this.$route.path.split('/')[1] })
            this.eval(this.data)
                .then(response => {
                        //計算結果を持っている状態にする
                        this.haveResult()

                        if (response.data.e_S_h == 0) {
                            response.data.e_S_h = '--'
                        }
                        if (response.data.e_CG_gen == 0) {
                            response.data.e_CG_gen = '--'
                        }
                        if (response.data.e_CG_sell == 0) {
                            response.data.e_CG_sell = '--'
                        }
                        if (response.data.e_PV_gen == 0) {
                            response.data.e_PV_gen = '--'
                        }
                        if (response.data.e_PV_sell == 0) {
                            response.data.e_PV_sell = '--'
                        }
                        if (response.data.e_S_sell == 0) {
                            response.data.e_S_sell = '--'
                        }
                        if (response.data.etA_AH == null) {
                            response.data.etA_AH = '--'
                        }

                        this.setResult(response.data)
                            //this.$route.path.split('/')[1] はsimple or detail
                        this.$router.push('/' + this.mode + '/result', () => {}, () => {})
                    //ローディングスピンを非表示にする
                    this.spinHide()
                }, (reject) => {
                    const errorResponse = reject.response.data
                    if (errorResponse.inputErrorMessages == undefined && errorResponse.preValidateMessage == undefined && errorResponse.error == undefined) {
                        this.addError('計算時にエラーが発生しました')
                        scroll(0, 0)
                    } else {
                        if (errorResponse.inputErrorMessages != undefined) {
                            for (let i = 0; i < errorResponse.inputErrorMessages.length; i++) {
                                let errorMessage = errorResponse.inputErrorMessages[i]
                                this.addError(this.getName(errorMessage['targetName']) + this.getError(errorMessage))
                            }
                        }
                        if (errorResponse.preValidateMessage != undefined) {
                            this.addError(errorResponse.preValidateMessage)
                        }
                        if (errorResponse.error != undefined) {
                            for (let i = 0; i < errorResponse.error.length; i++) {
                                this.addError(errorResponse.error[i])
                            }
                        }
                        scroll(0, -50)
                    }
                    //ローディングスピンを非表示にする
                    this.spinHide()
                })
        },
    }
}